


















import {Component, PropSync, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import Unit from "@/model/Unit";
import UnitApi from "@/module/thing/UnitApi";
import {default as Tunit} from '@/module/thing/Unit'

@Component({
  components: {},
})
export default class UnitSelect extends Vue {

  @PropSync('unit')
  private syncUnit!: Unit

  private api = Container.get(UnitApi)

  private units: Array<Unit> = []

  private async created() {
    this.units = await this.api.list()
  }

  private toTunit(unit: Unit): Tunit {
    return {name: unit.name, symbol: unit.symbol}
  }
}
